<template lang="pug">
  .main-container
    el-row.margin-bottom(v-if="!hasEditalAberto")
      el-col(:span="24")
        .button-cadastrar-container
          el-button(type="primary" size="medium" @click="openCadastrarModal")
            i.margin-right(class="fas fa-file-alt")
            span Cadastrar edital

    el-row
      el-col(:span="24")
        include commons/tableEditais.pug

    Pagination(:total="quantidadeResultados" :pagina="paginaAtual" :tamanhoPagina="tamanhoPagina" @changePage="changePage")

    app-modal-edital(
      v-if="isModalVisible",
      :title="modalTitle",
      :closeOutside="true",
      :hasFooter="true",
      :responsive="true",
      :editalVigente="editalVigente",
      :hasEncerrarButton="hasEncerrarButton",
      :isFieldsDisabled="isModalFieldsDisabled",
      :hasReabrirButton="hasReabrirButton",
      @closeModal="() => { reload() }",
      @finalizar="() => { reload() }"
    )

</template>

<script>
import { Pagination, AppNotificacao } from 'sicarf-components';
import AppModalEdital from '@/components/AppModalEdital';

import { getEncerrarEdital, getEditalByPerfil, downloadEditalById } from '@/services/editalService';

export default {
  name: 'listagemEditais',
  components: {
    Pagination,
    AppModalEdital
  },
  mixins: [
    AppNotificacao
  ],
  data () {
    return {
      isModalVisible: false,
      carregando: false,
      listEditais: [],
      modalTitle: 'Cadastrar edital',
      hasEditalAberto: false,
      editalVigente: null,
      hasEncerrarButton: true,
      isModalFieldsDisabled: false,
      hasReabrirButton: false,
      editalEmAberto: null,
      ultimoEditalEncerrado: null,
      tableActionsAberto: [
        { codigo: 'SOLICITACOES', label: 'Visualizar Edital', icon: 'fas fa-user-check' },
        { codigo: 'EDITAR', label: 'Editar', icon: 'fas fa-pencil' },
        { codigo: 'ENCERRAR', label: 'Encerrar', icon: 'fas fa-times-circle' },
        { codigo: 'BAIXAR_EDITAL', label: 'Baixar', icon: 'fas fa-arrow-circle-down' }
      ],
      tableActionsEncerrado: [
        { codigo: 'SOLICITACOES', label: 'Visualizar Edital', icon: 'fas fa-search' },
        { codigo: 'BAIXAR_EDITAL', label: 'Baixar', icon: 'fas fa-arrow-circle-down' }
      ],
      filtro: {},
      filtroSort: {},
      quantidadeResultados: 0,
      paginaAtual: 0,
      tamanhoPagina: 15,
    }
  },
  async created () {
    this.loadEditalData()
  },
  methods: {
    async loadEditalData () {
      const response = await getEditalByPerfil(this.filtro)
      this.listEditais = response.content
      this.handleSearch()

      // Ordena pelo último encerrado
      this.listEditais.sort((a, b) => {
        if (a.dataFim < b.dataFim) return 1
        if (a.dataFim > b.dataFim) return -1
      })

      this.editalEmAberto = this.listEditais.find((edital) => edital.situacao === 'ABERTO')

      if (this.editalEmAberto) {
        this.hasEditalAberto = true
        this.hasReabrirAction()
      }
    },

    reload () {
      this.loadEditalData()
      this.isModalVisible = false
    },

    openCadastrarModal () {
      this.modalTitle = 'Cadastrar edital'
      this.editalVigente = null
      this.isModalFieldsDisabled = false
      this.hasEncerrarButton = true
      this.isModalVisible = true
      this.hasReabrirButton = false
    },

    handleEditarAction (edital) {
      this.modalTitle = 'Editar edital'
      this.editalVigente = edital
      this.isModalFieldsDisabled = true
      this.hasEncerrarButton = false
      this.isModalVisible = true
      this.hasReabrirButton = false
    },

    handleReabrirAction (edital) {
      this.modalTitle = 'Reabrir edital'
      this.editalVigente = edital
      this.isModalFieldsDisabled = false
      this.hasEncerrarButton = false
      this.isModalVisible = true
      this.hasReabrirButton = true
    },

    async handleBaixarAction (edital) {
      let urlBase = process.env.VUE_APP_ROOT_URL;
      window.open(urlBase + "/publico/edital/baixar?idEdital=" + edital.id, "_blank");
    },

    async handleBaixarAction_ (edital) {
      const fileLink = document.createElement('a');
      const arquivo = await downloadEditalById(edital.id);

      if (arquivo) {
        const fileURL = new Blob([arquivo]);
        fileLink.setAttribute('download', 'Edital' + edital.numero + '.pdf');
        fileLink.href = window.URL.createObjectURL(fileURL);
        document.body.appendChild(fileLink);
        fileLink.click();
      }

      return Promise.resolve();
    },

    async handleEncerrarEdital () {
      await this.encerrarEdital()
    },

    handleTableActions (row, action) {
      switch (action.codigo) {
        case 'SOLICITACOES':
          this.goTo('solicitacoes/listagem', { idEdital: row.id })
          break
        case 'EDITAR':
          this.handleEditarAction(row)
          break
        case 'ENCERRAR':
          this.handleEncerrarEdital()
          break
        case 'REABRIR':
          this.handleReabrirAction(row)
          break
        default:
          this.handleBaixarAction(row)
          break
      }
    },

    goTo (route, params) {
      this.$router.push({
        name: route,
        params: params,
      })
    },

    async encerrarEdital () {
      this.confirmBox(this.$messages.ENCERRAR_EDITAL, this.$messages.TITULO_WARNING,
        async () => {
          try {
            await getEncerrarEdital();
            this.reload();
            this.hasEditalAberto = false;
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Edital encerrado com sucesso.');
          } catch (err) {
            console.error('Erro ao encerrar edital: ', err);
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Houve um erro ao encerrar o edital.');
          }
        },
        () => {})
    },

    formatDateFromTimestamp (value) {
      const date = new Date(value)

      const day = '0' + date.getDate()
      const month = '0' + (date.getMonth() + 1)
      const year = date.getFullYear()

      return `${day.substr(-2)}/${month.substr(-2)}/${year}`
    },

    // TODO: Validar sobre o uso de paginação, se sim, desenvolver o serviço responsável
    async handleSearch (searchValue, pagina = 0) {
      this.loading = true

      this.filtro = {}
      this.filtro.campoSimples = searchValue || '';
      this.filtro.pagina = pagina;
      this.filtro.ordem = this.filtroSort.ordem;
      this.filtro.ordemDirecao = this.filtroSort.ordemDirecao;
      const response = await getEditalByPerfil(this.filtro)
      this.listEditais = response.content
      this.quantidadeResultados = response.totalElements
      this.loading = false
    },

    changePage (newPage) {
      this.paginaAtual = newPage - 1;
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual)
    },

    // Se não houver edital em aberto, possibilita ao usuário reabrir a última edital ENCERRADA
    hasReabrirAction (edital) {
      const ultimoEditalEncerrado = this.listEditais.find((edital) => edital.situacao === 'ENCERRADO');
      const reabrirAction = [
        { codigo: 'SOLICITACOES', label: 'Visualizar Edital', icon: 'fas fa-search' },
        { codigo: 'REABRIR', label: 'Reabrir', icon: 'fas fa-sync-alt' },
        { codigo: 'BAIXAR_EDITAL', label: 'Baixar', icon: 'fas fa-arrow-circle-down' }
      ];

      let tableActions = this.tableActionsEncerrado;

      this.ultimoEditalEncerrado = ultimoEditalEncerrado;

      // Seta a opção de reabrir edital no menu actions ao último edital encerrado
      if (edital) {
        if (edital.id === ultimoEditalEncerrado.id && !this.editalEmAberto) {
          tableActions = reabrirAction;
        }
      }

      return tableActions;
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.button-cadastrar-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.card-title {
  color: $font-dark-color;
}

.text-dropdown {
  margin-left: 5px;
  font-weight: $font-bold;
}

// -------- Generics -------- \\
.margin-bottom {
  margin-bottom: 20px;
}

.margin-right {
  margin-right: 10px;
}

.margin-left {
  margin-left: 5px;
}

</style>
